module.exports = __webpack_public_path__ + "static/wakefield-free-bus-sm-8b6b902a9cff8f070ad03f3e4510e571.jpg";